export default {
  SET_INFOR_ORDER(state, data) {
    // Xoá đơn nháp
    if (typeof data != 'object') {
      const index = state.orders.findIndex(e => e.id === data)
      if (index > 0) {
        state.orderId = state.orders[index - 1].id
        localStorage.setItem('ORDER_ID', JSON.stringify(state.orderId))
      } else if (index == 0 && state.orders.length > 1) {
        state.orderId = state.orders[index + 1].id
        localStorage.setItem('ORDER_ID', JSON.stringify(state.orderId))
      }

      state.orders.splice(index, 1)
      // localStorage.setItem('ORDER', JSON.stringify(state.orders))
      return
    }
    //  case header chưa có đơn
    else if (state.orders == null) {
      state.orders = new Array
      state.orderId = data.id
      localStorage.setItem('ORDER_ID', JSON.stringify(state.orderId))
      state.orders.push(data)
      localStorage.setItem('ORDER', JSON.stringify(state.orders))
    } else {
      const index = state.orders.findIndex((e) => (e.id === data.id))
       //  case đơn thêm vào đã tồn tại
      if (index != -1) {
        state.orders[index] = data
      } else {
      //  case đơn thêm vào chưa tồn tại (thêm mới => chuyển id để chuyển về đơn đó)
        state.orders.push(data)
        state.orderId = data.id
        localStorage.setItem('ORDER_ID', JSON.stringify(state.orderId))
        localStorage.setItem('ORDER', JSON.stringify(state.orders))
      }
    }

    localStorage.setItem('ORDER', JSON.stringify(state.orders))
  },

  // Chuyển đơn khác dựa vào id
  SET_ID_ORDER(state, data) {
    state.orderId = data
    localStorage.setItem('ORDER_ID', JSON.stringify(state.orderId))
  },

  // Lưu đơn nháp 
  SET_SAVE_ORDER(state, data) {
    state.orderSave = data
    localStorage.setItem('ORDER_SAVE', JSON.stringify(data))
  }
};
